import {OverlayTrigger, Tooltip} from "react-bootstrap";
import React, {useRef} from "react";
import {FaCheck} from "react-icons/fa";
import {RxCross2} from "react-icons/rx";

export default function FundCompositionAccess(props) {

    const sourceFilter = props.sourceFilter;
    const noData = props.noData;
    const boxWidth = '250px';
    const colWidth = '200px';
    const col2Width = '40px';

    const target = useRef(null);

    const accessInd = <>{sourceFilter ? sourceFilter.globalAccess === 1 ? <FaCheck color={'green'}/> :
        <RxCross2 color={'red'}/> : noData}</>;

    return <>{sourceFilter ? <OverlayTrigger
        placement='auto'
        delay={{show: 500, hide: 0}}
        trigger={["hover", "focus"]}
        target={target}
        overlay={<Tooltip id="tooltip-bottom">
            <h3 className={'canopia2'}>Look-through Authorization</h3>
            {sourceFilter.amLookthroughAccess >= 0 && <>
                <div style={{marginTop: '10px'}}>
                    <h4 className={'canopia'}>Global AM Access</h4>
                </div>
                <div className={'flex-nowrap'} style={{width: boxWidth, padding: '0.55em 0.5em'}}>
                    <div className={"flex-00"} style={{flexBasis: colWidth}}>
                        {sourceFilter.amLookthroughAccess === 1 ? <>The access to the AM database is granted</> : <>No
                            access to the AM database</>}
                    </div>
                    <div className={"flex-00 right"} style={{flexBasis: col2Width}}>
                        {sourceFilter.amLookthroughAccess === 1 ? <FaCheck color={'green'}/> :
                            <RxCross2 color={'red'}/>}
                    </div>
                </div>
            </>}
            <div style={{marginTop: '10px'}}>
                <h4 className={'canopia'}>{sourceFilter.amName}</h4>
            </div>
            <div className={'flex-nowrap'} style={{width: boxWidth, padding: '0.55em 0.5em'}}>
                <div className={"flex-00"} style={{flexBasis: colWidth}}>
                    Authorization Type
                </div>
                <div className={"flex-00 right"} style={{flexBasis: col2Width}}>
                    {sourceFilter.amAccessType}
                </div>
            </div>
            {sourceFilter.ndaAccess >= 0 &&
                <div className={'flex-nowrap'} style={{width: boxWidth, padding: '0.55em 0.5em'}}>
                    <div className={"flex-00"} style={{flexBasis: colWidth}}>
                        Client Access
                    </div>
                    <div className={"flex-00 right"} style={{flexBasis: col2Width}}>
                        {sourceFilter.ndaAccess === 1 ? <FaCheck color={'green'}/> : <RxCross2 color={'red'}/>}
                    </div>
                </div>}
        </Tooltip>}
        defaultShow={false}>
        {/*need to set display to prevent conflict between tr mouseover and tooltip*/}
        <span style={{display: 'inline-block'}}>
            {accessInd}
        </span>
    </OverlayTrigger> : accessInd}</>;
}